/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module LogsModule */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import * as l10n from './logs-signpost.l10n';
import { customTemplates } from '../../constants/logs-signpost.constants';
import { ILogsSelectedSignpostConfig } from '../../logs.types';
import './logs-signpost.component.less';
import { ILogsSignpostStates, LogsSignpostStore } from '../../services/logs-signpost.store';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component for deciding which signpost cutom or defualt to be displayed.
 * @author Suraj Kumar, Yogesh Patil
 */
@Component({
    selector: 'logs-signpost',
    templateUrl: './logs-signpost.component.html',
})
export class LogsSignpostComponent implements OnInit {
    /**
     * Contains selected signpost name and its respective config key.
     */
    @Input()
    public selectedSignpostConfig: ILogsSelectedSignpostConfig;

    /**
     * The ID of the pool used to filter logs from a VS.
     */
    @Input()
    public poolId?: string;

    public readonly l10nKeys = l10nKeys;

    /**
     * Flag indicating if its custom signpost or default.
     */
    public isCustomComponent = false;

    constructor(
        l10nService: L10nService,
        public readonly logsSignpostStore: LogsSignpostStore<ILogsSignpostStates>,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        this.isCustomComponent = Object.values(customTemplates).includes(
            this.selectedSignpostConfig.configKey,
        );

        this.logsSignpostStore.setLogSignpostGroupby(this.selectedSignpostConfig);
    }
}
